export default __webpack_public_path__ + "static/media/consulting.22810faf.svg";